import axios from "axios";
import { logger } from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---- 401 → silent refresh → retry once -----------------------------------
let refreshPromise = null;
const refreshAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const url = original?.url || "";

    // Only auto-refresh once per request, and never for the refresh/login/logout paths.
    const isAuthEndpoint = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/logout");
    if (status === 401 && !original?._retried && !isAuthEndpoint) {
      original._retried = true;
      try {
        await refreshAccessToken();
        return api(original);
      } catch (e) {
        logger.warn("Refresh token rotation failed:", e?.message || e);
        // Bubble up original 401 — auth-context handles signing out.
        throw error;
      }
    }
    throw error;
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
